import { SIGN_IN_GA_CATEGORY, GaActionText } from './constants';
import { createGaActionCreator } from '../../utils';
import { GA } from '../../../middleware/google-analytics';

const TRACK_MADE_IT_TO_SIGN_IN = '@@startsignin/TRACK_MADE_IT_TO_SIGN_IN';
const TRIGGER_USER_TYPE_CHANGE = '@@startsignin/TRIGGER_USER_TYPE_CHANGE';

export const StartSignInPageActions = {
    TRACK_MADE_IT_TO_SIGN_IN,
    TRIGGER_USER_TYPE_CHANGE,
};

export const trackMadeItToSignIn = () => {
    const baseAction = createGaActionCreator(
        TRACK_MADE_IT_TO_SIGN_IN,
        SIGN_IN_GA_CATEGORY,
        GaActionText.trackMadeItToSignIn
    );

    if (window.dataLayer) {
        window.dataLayer.push({
            // eslint-disable-next-line
            event: `[${SIGN_IN_GA_CATEGORY}] ${GaActionText.trackMadeItToSignIn}`,
        });
    }

    return baseAction;
};

export const triggerUserTypeChange = response => ({
    type: TRIGGER_USER_TYPE_CHANGE,
    meta: {
        analytics: {
            type: GA.AnalyticsTypes.SetDimension,
            settingType: GA.SettingType.CustomDimension,
            index: GA.DimensionKeys.UserType,
            value: response.user_tracking_type,
        },
    },
});

export const StartSignInPageActionCreators = {
    trackMadeItToSignIn,
    triggerUserTypeChange,
};
